export function calcularHorasTrabalhadas(dia) {
  const toDate = (time) => new Date(`1970-01-01T${time}:00`);

  const addDay = (date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  };

  let start = toDate(dia.start_time);
  let lunchStart = toDate(dia.lunch_start);
  let lunchEnd = toDate(dia.lunch_end);
  let end = toDate(dia.end_time);

  // ----------------------------
  // Ajuste de virada de dia
  // ----------------------------
  if (lunchStart <= start) {
    lunchStart = addDay(lunchStart);
  }

  if (lunchEnd <= lunchStart) {
    lunchEnd = addDay(lunchEnd);
  }

  if (end <= lunchEnd) {
    end = addDay(end);
  }

  const morning = lunchStart - start;
  const afternoon = end - lunchEnd;

  let totalMinutes = (morning + afternoon) / (1000 * 60);

  // Proteção contra negativo
  if (totalMinutes <= 0) return "00:00";

  // Proteção contra carga absurda (>16h)
  if (totalMinutes > 16 * 60) return "00:00";

  const horas = Math.floor(totalMinutes / 60);
  const minutos = Math.floor(totalMinutes % 60);

  return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
}
